import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, vModelText as _vModelText, withModifiers as _withModifiers, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = {
  key: 1,
  class: "pl-4 py-4"
};
const _hoisted_2 = {
  key: 0
};
const _hoisted_3 = {
  key: 1
};
const _hoisted_4 = {
  class: "flex flex-col flex-1 w-full h-full bg-white"
};
const _hoisted_5 = {
  class: "flex justify-between items-center pl-4 pr-10 bar-border-bottom border-gray-300"
};
const _hoisted_6 = {
  class: "p-2"
};
const _hoisted_7 = {
  class: "flex"
};
const _hoisted_8 = {
  class: "text-sm text-gray-800 bg-white"
};
const _hoisted_9 = ["href"];
const _hoisted_10 = {
  class: "flex py-1"
};
const _hoisted_11 = {
  class: "py-2 inline-block col-span-2"
};
const _hoisted_12 = {
  class: "overflow-y-auto grid grid-cols-3 print:overflow-hidden"
};
const _hoisted_13 = {
  class: "inline-block print:inline py-2 min-w-full align-middle bg-gray-100 col-span-2"
};
const _hoisted_14 = {
  class: "rounded bg-white w-10/12 shadow my-10 mx-auto p-10"
};
const _hoisted_15 = {
  class: "ts"
};
const _hoisted_16 = {
  class: "w-full py-2 flex"
};
const _hoisted_17 = {
  class: "w-6/12"
};
const _hoisted_18 = ["disabled"];
const _hoisted_19 = {
  class: "warning"
};
const _hoisted_20 = {
  class: "w-6/12 pl-2"
};
const _hoisted_21 = ["disabled"];
const _hoisted_22 = {
  class: "warning"
};
const _hoisted_23 = {
  class: "w-full py-2 flex"
};
const _hoisted_24 = {
  class: "w-6/12"
};
const _hoisted_25 = ["disabled"];
const _hoisted_26 = {
  class: "warning"
};
const _hoisted_27 = {
  class: "w-6/12 pl-2"
};
const _hoisted_28 = ["disabled"];
const _hoisted_29 = {
  class: "warning"
};
const _hoisted_30 = {
  class: ""
};
const _hoisted_31 = {
  class: "w-full py-2"
};
const _hoisted_32 = {
  class: ""
};
const _hoisted_33 = {
  class: "w-full py-2"
};
const _hoisted_34 = {
  class: ""
};
const _hoisted_35 = {
  class: "w-full py-2"
};
const _hoisted_36 = {
  class: "py-5 h-16 flex mt-5"
};
const _hoisted_37 = {
  class: "block font-bold text-base py-2"
};
const _hoisted_38 = {
  class: "bg-gray-100 rounded h-auto py-2 px-10 pb-16"
};
const _hoisted_39 = {
  class: "flex justify-between py-2"
};
const _hoisted_40 = {
  key: 0,
  class: "flex justify-center w-11/12"
};
const _hoisted_41 = ["src"];
const _hoisted_42 = {
  key: 1,
  class: "w-11/12 flex justify-center"
};
const _hoisted_43 = {
  class: "w-1/12 pr-1 self-center"
};
const _hoisted_44 = {
  class: "flex justify-between"
};
const _hoisted_45 = {
  class: "w-11/12 px-2"
};
const _hoisted_46 = {
  key: 0,
  class: "pr-10 mb-2"
};
const _hoisted_47 = {
  key: 1,
  class: "pr-10 mb-2"
};
const _hoisted_48 = {
  key: 2,
  class: "pr-10 mb-2"
};
const _hoisted_49 = {
  class: "w-1/12 pr-1 self-center"
};
const _hoisted_50 = {
  class: ""
};
const _hoisted_51 = {
  class: "flex justify-between"
};
const _hoisted_52 = {
  class: "w-11/12 flex justify-center"
};
const _hoisted_53 = {
  class: "w-1/12 pr-1 self-center"
};
const _hoisted_54 = {
  class: ""
};
const _hoisted_55 = {
  class: "flex justify-between"
};
const _hoisted_56 = {
  class: "w-1/12 pr-1 self-center"
};
const _hoisted_57 = {
  class: ""
};
const _hoisted_58 = {
  class: "bg-white py-4 px-12"
};
const _hoisted_59 = {
  class: "ml-auto"
};
const _hoisted_60 = {
  class: "bg-yellow-200 shadow-sm opacity-80 p-1 px-4"
};
import { reactive, onMounted, nextTick, computed, ref } from 'vue';
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
import Loader from '@/components/Loader.vue';
import LlSwitch from '@/components/LlSwitch.vue';
import LlTabs from '@/components/LlTabs.vue';
import UpdateSubjectModal from './UpdateSubjectModal.vue';
import UpdateLogoModal from './UpdateLogoModal.vue';
import UpdateButtonColorModal from './UpdateButtonColorModal.vue';
import UpdateAccountSummaryModal from './UpdateAccountSummaryModal.vue';
import UpdateIntroModal from './UpdateIntroModal.vue';
import EmailSidebar from './EmailSidebar.vue';
import { useInvoiceEmailStore } from './useInvoiceEmailStore.js';
import RouteService from '@/services/RouteService';
import MainHeader from '@/components/MainHeader.vue';
import UpgradeToProExpenseAttachmentsModals from '@/components/modals/UpgradeToProExpenseAttachmentsModals.vue';
import { useCompanyStore } from '@/services/UserService/useCompanyStore';
import AttachmentItem from './AttachmentItem.vue';
import { useSupportChat } from '@/composables/useSupportChat';
import { isValidEmail, isValidSingleEmail } from '@/services/utils';
import { getSenderNameError } from '@/utils/senderNameValidation';
import LlSelect from '@/components/LlSelect.vue';
export default {
  __name: 'InvoiceEmail',
  props: {
    userService: {
      type: Object,
      required: true
    },
    rootScope: {
      type: Object,
      required: true
    },
    tracking: {
      type: Object,
      required: true
    },
    state: {
      type: Object,
      required: true
    },
    alerts: {
      type: Object,
      required: true
    },
    leanLawAuth: {
      type: Object,
      required: true
    }
  },
  setup(__props) {
    const {
      getSupportUrl: _getSupportUrl
    } = useSupportChat();
    const emailServiceSupportUrl = computed(() => _getSupportUrl('emailServiceSetup'));
    const emailTabs = [{
      value: '0',
      label: 'Invoice Email',
      dataCy: 'tab-invoice-email'
    }, {
      value: '1',
      label: 'Reminders',
      dataCy: 'tab-reminders'
    }, {
      value: '2',
      label: 'Trust Request',
      dataCy: 'tab-trust-request'
    }];
    const props = __props;
    let state = reactive({
      loading: false,
      subjectOptions: [],
      reminderSubjectOptions: [],
      trustRequestSubjectOptions: [],
      showModal: false,
      me: {},
      saving: false,
      loadingSubjectId: false,
      unsaved: false,
      selectedId: undefined,
      reminderSubject: undefined,
      subject: undefined,
      trustRequestSubject: undefined,
      enabled: true,
      fromEmail: '',
      fromName: '',
      isEmailValid: true,
      emailErrorMessage: '',
      fromNameErrorMessage: '',
      emailBccErrorMessage: '',
      emailCcErrorMessage: '',
      showIntroChangeOnHover: false,
      buttonColor: undefined,
      reminderMode: '0',
      showExpenseWarning: false,
      selectItemsChanged: false,
      showUpgradeToProExpenseAttachmentsModals: false,
      routeService: undefined,
      showGravityWarning: false
    });
    const invoiceEmailStore = useInvoiceEmailStore();
    const companyStore = useCompanyStore();
    invoiceEmailStore.alerts = props.alerts;
    invoiceEmailStore.$subscribe((mutation, storeState) => {
      state.loading = storeState.loading;
    });
    onMounted(async () => {
      await getMe();
      state.subjectOptions = invoiceEmailStore.getSubjectOptions(state);
      state.reminderSubjectOptions = invoiceEmailStore.getReminderSubjectOptions(state);
      state.trustRequestSubjectOptions = invoiceEmailStore.getTrustRequestSubjectOptions(state);
      invoiceEmailStore.subjectOptions = state.subjectOptions;
      invoiceEmailStore.reminderSubjectOptions = state.reminderSubjectOptions;
      invoiceEmailStore.trustRequestSubjectOptions = state.trustRequestSubjectOptions;
      await getInvoiceEmail();
      state.routeService = new RouteService(props);
      const deactivate = state.routeService.rootScopeChange().$on('$stateChangeStart', event => {
        if (somethingChanged.value) {
          state.unsaved = true;
          setTimeout(() => {
            state.unsaved = false;
          }, 4000);
          event.preventDefault();
        } else {
          deactivate();
        }
      });
    });
    function invoiceEmailStatusToggle() {
      state.enabled = !state.enabled;
    }
    function subjectChange() {
      nextTick(() => {
        if (invoiceEmailStore.invoiceDelivery.subjectId === 'custom') {
          invoiceEmailStore.toggleUpdateSubjectModal(invoiceEmailStore.customSubject, state.reminderMode);
        }
      });
    }
    function reminderSubjectChange() {
      nextTick(() => {
        if (invoiceEmailStore.invoiceDelivery.reminderSubjectId === 'custom') {
          invoiceEmailStore.toggleUpdateSubjectModal(invoiceEmailStore.customReminderSubject, state.reminderMode);
        }
      });
    }
    function getLogoUrl() {
      return `${props.leanLawAuth.domain}/v1/invoicedeliverysettings/logo`;
    }
    function trustRequestChange() {
      nextTick(() => {
        if (invoiceEmailStore.invoiceDelivery.trustRequestSubjectId === 'custom') {
          invoiceEmailStore.toggleUpdateSubjectModal(invoiceEmailStore.customTrustRequestSubject, state.reminderMode);
        }
      });
    }
    function fromChange() {
      invoiceEmailStore.updateFromInfo();
    }
    function openSupportLink() {
      window.open(_getSupportUrl('expenseAttachments'), '_blank', 'noopener,noreferrer');
    }
    function subjectLogo() {
      invoiceEmailStore.toggleUpdateLogoModal();
    }
    function introChange() {
      invoiceEmailStore.toggleUpdateIntroModal();
    }
    function buttonColorChange() {
      invoiceEmailStore.toggleButtonColorChangeModal();
    }
    function accountSummaryChange() {
      invoiceEmailStore.toggleAccountSummaryChangeModal();
    }
    function isEnabled(modules, moduleId) {
      return modules?.find(module => module.id === moduleId)?.enabled;
    }
    function confirmExpenseAttachments() {
      var expenseModule = state.modules.find(x => x.id === 9);
      expenseModule.enabled = !expenseModule.enabled;
      state.selectItemsChanged = true;
      state.showExpenseWarning = false;
    }
    async function getMe() {
      const me = await props.userService.getMe();
      state.me = me;
      state.emailCc = me.company?.settings?.emailCc;
      state.emailBcc = me.company?.settings?.emailBcc;
    }
    async function getInvoiceEmail() {
      state.loadingSubjectId = true;
      await invoiceEmailStore.getInvoiceDeliveryDetail();
      const {
        subject,
        reminderSubject,
        trustRequestSubject,
        body,
        reminderBody,
        trustRequestBody,
        enabled,
        fromEmail,
        fromName,
        modules,
        buttonColor
      } = invoiceEmailStore.invoiceDelivery;
      state.enabled = enabled;
      state.fromEmail = fromEmail;
      state.buttonColor = buttonColor || state.buttonColor;
      state.modules = modules?.filter(x => x.state.toLowerCase() !== 'disabled' && (!state.me?.features?.emailCustomization || x.state.toLowerCase() !== 'comingsoon') && !(x.id == 12 && !state.me?.features?.invoiceSummaryPage))?.sort((a, b) => a.name.localeCompare(b.name));
      if (!body) {
        state.body = invoiceEmailStore.getDefaultBody(state);
      } else {
        state.body = body;
      }
      if (!reminderBody) {
        state.reminderBody = invoiceEmailStore.getDefaultReminderBody(state);
      } else {
        state.reminderBody = reminderBody;
      }
      if (!trustRequestBody) {
        state.trustRequestBody = invoiceEmailStore.getDefaultTrustRequestBody(state);
      } else {
        state.trustRequestBody = trustRequestBody;
      }
      if (subject) {
        invoiceEmailStore.invoiceDelivery.subjectId = subject;
        if (!state.subjectOptions.find(sub => sub.value === subject)) {
          state.customSubject = subject;
          invoiceEmailStore.customSubject = subject;
          state.subjectOptions.unshift({
            label: subject,
            value: subject
          });
        }
      }
      if (reminderSubject) {
        invoiceEmailStore.invoiceDelivery.reminderSubjectId = reminderSubject;
        if (!state.reminderSubjectOptions.find(sub => sub.value === reminderSubject)) {
          state.customReminderSubject = reminderSubject;
          invoiceEmailStore.customReminderSubject = reminderSubject;
          state.reminderSubjectOptions.unshift({
            label: reminderSubject,
            value: reminderSubject
          });
        }
      }
      if (trustRequestSubject) {
        invoiceEmailStore.invoiceDelivery.trustRequestSubjectId = trustRequestSubject;
        if (!state.trustRequestSubjectOptions.find(sub => sub.value === trustRequestSubject)) {
          state.customTrustRequestSubject = trustRequestSubject;
          invoiceEmailStore.customTrustRequestSubject = trustRequestSubject;
          state.trustRequestSubjectOptions.unshift({
            label: trustRequestSubject,
            value: trustRequestSubject
          });
        }
      }
      state.loadingSubjectId = false;
      if (!fromName) {
        invoiceEmailStore.invoiceDelivery.fromName = state.me.company?.name;
        fromChange();
      } else {
        state.fromName = fromName;
      }
      validateEmail();
      validateFromName();
    }
    function validateFromName() {
      state.fromNameErrorMessage = getSenderNameError(invoiceEmailStore.invoiceDelivery.fromName);
    }
    function validateEmail() {
      /**
       * Using centralized email validation from utils
       * For "From" email, we need to use single email validation since this will be used
       * as the sender address and cannot contain multiple emails
       */
      if (isValidSingleEmail(invoiceEmailStore.invoiceDelivery.fromEmail)) {
        state.isEmailValid = true;
        state.emailErrorMessage = '';
      } else {
        state.isEmailValid = false;
        state.emailErrorMessage = 'Please enter a valid sender email address. The sender field can only contain a single email address.';
      }
    }
    function validateEmails(emailString, isCC) {
      if (!emailString) return;
      var emails = emailString.split(','); // Split the input string into an array of emails
      var invalidEmails = []; // To store invalid emails
      emails = emails.filter(email => email.trim() !== ''); // Remove empty strings

      emails.forEach(function (email) {
        // Trim spaces from each email
        var trimmedEmail = email.trim();
        if (!isValidEmail(trimmedEmail)) {
          // If the email does not match the regex, add it to the invalid emails list
          invalidEmails.push(trimmedEmail);
        }
      });
      if (invalidEmails.length > 0) {
        // If there are any invalid emails, set the state accordingly
        state.isEmailValid = false;
        isCC ? state.emailCcErrorMessage = 'Invalid email addresses: ' + invalidEmails.join(', ') : state.emailBccErrorMessage = 'Invalid email addresses: ' + invalidEmails.join(', ');
      } else {
        // All emails are valid
        state.isEmailValid = true;
        isCC ? state.emailCcErrorMessage = '' : state.emailBccErrorMessage = '';
      }
    }
    function update() {
      if (!state.isEmailValid) return;
      if (invoiceEmailStore.invoiceDelivery.subjectId === 'custom') {
        invoiceEmailStore.invoiceDelivery.subjectId = invoiceEmailStore.customSubject;
      }
      if (invoiceEmailStore.invoiceDelivery.reminderSubjectId === 'custom') {
        invoiceEmailStore.invoiceDelivery.reminderSubjectId = invoiceEmailStore.customReminderSubject;
      }
      if (invoiceEmailStore.invoiceDelivery.trustRequestSubjectId === 'custom') {
        invoiceEmailStore.invoiceDelivery.trustRequestSubjectId = invoiceEmailStore.customTrustRequestSubject;
      }
      if (!invoiceEmailStore.invoiceDelivery.subjectId) {
        props.alerts.error('A subject is required.');
        return;
      }
      validateFromName();
      if (state.fromNameErrorMessage) {
        props.alerts.error(state.fromNameErrorMessage);
        return;
      }
      if (state.me?.features?.emailCustomization && invoiceEmailStore.invoiceDelivery.fromEmail) {
        state.enabled = true;
      }
      state.saving = true;
      invoiceEmailStore.sentInvoiceDeliveryDetail({
        subject: invoiceEmailStore.invoiceDelivery.subjectId,
        reminderSubject: invoiceEmailStore.invoiceDelivery.reminderSubjectId,
        trustRequestSubject: invoiceEmailStore.invoiceDelivery.trustRequestSubjectId,
        body: state.body,
        reminderBody: state.reminderBody,
        trustRequestBody: state.trustRequestBody,
        fromEmail: invoiceEmailStore.invoiceDelivery.fromEmail,
        fromName: invoiceEmailStore.invoiceDelivery.fromName,
        buttonColor: state.buttonColor,
        enabled: state.enabled,
        modules: state.modules
      }).then(saved => {
        if (!saved) return;
        state.fromEmail = invoiceEmailStore.invoiceDelivery.fromEmail;
        state.fromName = invoiceEmailStore.invoiceDelivery.fromName;
        const update = {
          settings: {
            emailCc: state.emailCc,
            emailBcc: state.emailBcc
          }
        };
        companyStore.updateMyCompany(update).then(() => {
          state.me.company.settings.emailBcc = state.emailBcc;
          state.me.company.settings.emailCc = state.emailCc;
        });
      });
      state.selectItemsChanged = false;
      state.saving = false;
    }
    function cancel() {
      invoiceEmailStore.invoiceDelivery.subjectId = state.subject;
      invoiceEmailStore.invoiceDelivery.reminderSubjectId = state.reminderSubject;
      invoiceEmailStore.invoiceDelivery.trustRequestSubjectId = state.trustRequestSubject;
      invoiceEmailStore.invoiceDelivery.fromEmail = state.fromEmail;
      invoiceEmailStore.invoiceDelivery.fromName = state.fromName;
      state.body = invoiceEmailStore.invoiceDelivery.body || invoiceEmailStore.getDefaultBody(state);
      state.body = invoiceEmailStore.invoiceDelivery.reminderBody || invoiceEmailStore.getDefaultReminderBody(state);
      state.trustRequestBody = invoiceEmailStore.invoiceDelivery.trustRequestBody || invoiceEmailStore.getDefaultTrustRequestBody(state);
      state.buttonColor = undefined;
      invoiceEmailStore.invoiceDelivery.buttonColor = state.buttonColor;
      state.selectItemsChanged = false;

      // Reset email CC and BCC fields to company settings values
      state.emailCc = state.me.company?.settings?.emailCc;
      state.emailBcc = state.me.company?.settings?.emailBcc;

      // Clear any error messages
      state.emailCcErrorMessage = '';
      state.emailBccErrorMessage = '';
      getInvoiceEmail();
    }
    const showPayBalanceButton = computed(() => {
      const {
        modules
      } = invoiceEmailStore.invoiceDelivery;
      if (modules) {
        var payFullBalanceModule = modules.find(x => x.id === 1);
        if (payFullBalanceModule?.enabled) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    });
    const showPayInvoiceButton = computed(() => {
      const {
        modules
      } = invoiceEmailStore.invoiceDelivery;
      if (modules) {
        var payInvoiceModule = modules.find(x => x.id === 8);
        if (payInvoiceModule?.enabled) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    });
    const somethingChanged = computed(() => {
      const {
        subject,
        reminderSubject,
        trustRequestSubject,
        enabled,
        body,
        reminderBody,
        trustRequestBody,
        fromEmail,
        fromName,
        buttonColor
      } = invoiceEmailStore.invoiceDelivery;
      const {
        emailCc,
        emailBcc
      } = state.me.company?.settings || {};
      if (enabled !== state.enabled) {
        return true;
      }
      const companyName = state.me.company?.name;
      if (fromName !== state.fromName && (fromName !== companyName || fromName === companyName && state.fromName !== companyName)) {
        return true;
      }
      if (fromEmail !== state.fromEmail) {
        return true;
      }
      if (emailCc !== state.emailCc) {
        return true;
      }
      if (emailBcc !== state.emailBcc) {
        return true;
      }
      if (invoiceEmailStore?.invoiceDelivery.subjectId && subject !== invoiceEmailStore?.invoiceDelivery.subjectId) {
        return true;
      }
      if (invoiceEmailStore?.invoiceDelivery.reminderSubjectId && reminderSubject !== invoiceEmailStore?.invoiceDelivery.reminderSubjectId) {
        return true;
      }
      if (invoiceEmailStore?.invoiceDelivery.trustRequestSubjectId && trustRequestSubject !== invoiceEmailStore?.invoiceDelivery.trustRequestSubjectId) {
        return true;
      }
      if (buttonColor !== state.buttonColor) {
        return true;
      }
      if (body !== state.body && state.body !== invoiceEmailStore.getDefaultBody(state)) {
        return true;
      }
      if (reminderBody !== state.reminderBody && state.reminderBody !== invoiceEmailStore.getDefaultReminderBody(state)) {
        return true;
      }
      if (trustRequestBody !== state.trustRequestBody && state.trustRequestBody !== invoiceEmailStore.getDefaultTrustRequestBody(state)) {
        return true;
      }
      if (state.selectItemsChanged) {
        return true;
      }
      return false;
    });
    return (_ctx, _cache) => {
      const _component_v_card_text = _resolveComponent("v-card-text");
      const _component_v_card_actions = _resolveComponent("v-card-actions");
      const _component_v_card = _resolveComponent("v-card");
      const _component_v_dialog = _resolveComponent("v-dialog");
      const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader");
      return _unref(state).loading ? (_openBlock(), _createBlock(Loader, {
        key: 0,
        what: 'Invoice Email Settings',
        class: "mt-32"
      })) : (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_v_dialog, {
        modelValue: _unref(state).showExpenseWarning,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _unref(state).showExpenseWarning = $event),
        width: "500"
      }, {
        default: _withCtx(() => [_createVNode(_component_v_card, {
          title: "Include Attachments"
        }, {
          default: _withCtx(() => [_createVNode(_component_v_card_text, null, {
            default: _withCtx(() => [!isEnabled(_unref(state).modules, 9) ? (_openBlock(), _createElementBlock("div", _hoisted_2, " Are you sure? If you enable this setting, all future invoice emails will automatically include any expense attachments. ")) : (_openBlock(), _createElementBlock("div", _hoisted_3, " Are you sure? If you disable this setting, all future invoice emails will not include expenses attachments by default. You will have to manually choose to include expense attachments to emails or enable automatic receipt attachments at the client level. "))]),
            _: 1
          }), _createVNode(_component_v_card_actions, null, {
            default: _withCtx(() => [_createVNode(LlSecondaryButton, {
              color: "primary",
              onClick: _cache[0] || (_cache[0] = $event => confirmExpenseAttachments())
            }, {
              default: _withCtx(() => [...(_cache[36] || (_cache[36] = [_createTextVNode(" OK ", -1)]))]),
              _: 1
            }), _createVNode(LlSecondaryButton, {
              onClick: _cache[1] || (_cache[1] = $event => _unref(state).showExpenseWarning = false)
            }, {
              default: _withCtx(() => [...(_cache[37] || (_cache[37] = [_createTextVNode("Cancel", -1)]))]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_v_dialog, {
        modelValue: _unref(state).showUpgradeToProExpenseAttachmentsModals,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => _unref(state).showUpgradeToProExpenseAttachmentsModals = $event),
        width: "700"
      }, {
        default: _withCtx(() => [_createVNode(UpgradeToProExpenseAttachmentsModals, {
          routeService: _unref(state).routeService,
          tracking: props.tracking,
          onCancel: _cache[3] || (_cache[3] = $event => _unref(state).showUpgradeToProExpenseAttachmentsModals = false),
          onOpenSupportLink: _cache[4] || (_cache[4] = $event => openSupportLink())
        }, null, 8, ["routeService", "tracking"])]),
        _: 1
      }, 8, ["modelValue"]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createVNode(MainHeader, {
        content: "Email Settings"
      }), _cache[38] || (_cache[38] = _createElementVNode("div", {
        class: "text-lg font-bold py-1.5"
      }, [_createElementVNode("span", {
        class: "bg-green-100 text-green-dark text-xs font-lg mx-2 px-2 py-0.5 rounded-md dark:text-green-light border border-green-light"
      }, "New")], -1))]), _createElementVNode("div", _hoisted_8, [_cache[39] || (_cache[39] = _createTextVNode(" Add a more personalized touch when sending invoices to your Clients. Enhance your emails by providing more data and context about the value your firm delivered to your clients. We will still create and use a QuickBooks Online invoice for all your invoicing needs. ", -1)), _createElementVNode("a", {
        href: emailServiceSupportUrl.value
      }, "Click here", 8, _hoisted_9), _cache[40] || (_cache[40] = _createTextVNode(" to learn more about the settings you see below, or for help getting set up. ", -1))])]), _withDirectives(_createElementVNode("div", null, [_createElementVNode("div", _hoisted_10, [_createElementVNode("div", {
        class: "py-1.5 px-1 cursor-pointer",
        onClick: invoiceEmailStatusToggle
      }, _toDisplayString(_unref(state).enabled ? 'Enabled' : 'Disabled'), 1), _createVNode(LlSwitch, {
        modelValue: _unref(state).enabled,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => _unref(state).enabled = $event)
      }, null, 8, ["modelValue"])])], 512), [[_vShow, !_unref(state).me?.features?.emailCustomization]])]), _createElementVNode("div", _hoisted_11, [_createVNode(LlTabs, {
        modelValue: _unref(state).reminderMode,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => _unref(state).reminderMode = $event),
        items: emailTabs
      }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_unref(invoiceEmailStore).showUpdateSubjectModal ? (_openBlock(), _createBlock(UpdateSubjectModal, {
        key: 0,
        reminderMode: _unref(state).reminderMode,
        alerts: __props.alerts
      }, null, 8, ["reminderMode", "alerts"])) : _createCommentVNode("", true), _unref(invoiceEmailStore).showUpdateLogoModal ? (_openBlock(), _createBlock(UpdateLogoModal, {
        key: 1,
        leanLawAuth: props.leanLawAuth
      }, null, 8, ["leanLawAuth"])) : _createCommentVNode("", true), _unref(invoiceEmailStore).showUpdateIntroModal ? (_openBlock(), _createBlock(UpdateIntroModal, {
        key: 2,
        state: _unref(state),
        alerts: __props.alerts
      }, null, 8, ["state", "alerts"])) : _createCommentVNode("", true), _unref(invoiceEmailStore).showButtonColorModal ? (_openBlock(), _createBlock(UpdateButtonColorModal, {
        key: 3,
        state: _unref(state)
      }, null, 8, ["state"])) : _createCommentVNode("", true), _createVNode(_component_v_dialog, {
        modelValue: _unref(invoiceEmailStore).showAccoucntSummaryModal,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => _unref(invoiceEmailStore).showAccoucntSummaryModal = $event),
        width: "1100"
      }, {
        default: _withCtx(() => [_createVNode(UpdateAccountSummaryModal, {
          onCloseDialog: _cache[8] || (_cache[8] = $event => accountSummaryChange())
        })]),
        _: 1
      }, 8, ["modelValue"]), _createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_cache[45] || (_cache[45] = _createElementVNode("div", {
        class: "flex"
      }, [_createElementVNode("span", {
        class: "block font-bold text-base py-2 w-6/12"
      }, [_createTextVNode("Sender Info "), _createElementVNode("span", {
        class: "text-gray-400 font-normal text-sm"
      }, "(required)")]), _createElementVNode("span", {
        class: "block font-bold text-base py-2 w-6/12"
      }, "Recipient Info ")], -1)), _createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [_cache[41] || (_cache[41] = _createElementVNode("span", {
        class: "block font-bold text-base py-2 w-6/12"
      }, [_createTextVNode("Name "), _createElementVNode("span", {
        class: "text-gray-400 font-normal text-sm"
      }, "(sender)")], -1)), _withDirectives(_createElementVNode("input", {
        disabled: _unref(state).reminderMode === '1' || _unref(state).reminderMode === '2',
        "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => _unref(invoiceEmailStore).invoiceDelivery.fromName = $event),
        class: "multiselect",
        type: "text",
        placeholder: "Name",
        required: "",
        onBlur: validateFromName,
        onChange: fromChange
      }, null, 40, _hoisted_18), [[_vModelText, _unref(invoiceEmailStore).invoiceDelivery.fromName]]), _createElementVNode("span", _hoisted_19, _toDisplayString(_unref(state).fromNameErrorMessage), 1)]), _createElementVNode("div", _hoisted_20, [_cache[42] || (_cache[42] = _createElementVNode("span", {
        class: "block font-bold text-base py-2 w-6/12"
      }, [_createTextVNode("Cc "), _createElementVNode("span", {
        class: "text-gray-400 font-normal text-sm"
      }, "(recipient)")], -1)), _withDirectives(_createElementVNode("input", {
        disabled: _unref(state).reminderMode === '1' || _unref(state).reminderMode === '2',
        "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => _unref(state).emailCc = $event),
        class: "multiselect",
        type: "text",
        onBlur: _cache[12] || (_cache[12] = $event => validateEmails(_unref(state).emailCc, true)),
        placeholder: "Separate multiple emails with commas",
        required: ""
      }, null, 40, _hoisted_21), [[_vModelText, _unref(state).emailCc]]), _createElementVNode("span", _hoisted_22, _toDisplayString(_unref(state).emailCcErrorMessage), 1)])]), _createElementVNode("div", _hoisted_23, [_createElementVNode("div", _hoisted_24, [_cache[43] || (_cache[43] = _createElementVNode("span", {
        class: "block font-bold text-base py-2 w-6/12"
      }, [_createTextVNode("Email "), _createElementVNode("span", {
        class: "text-gray-400 font-normal text-sm"
      }, "(sender)")], -1)), _withDirectives(_createElementVNode("input", {
        disabled: _unref(state).reminderMode === '1' || _unref(state).reminderMode === '2',
        "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => _unref(invoiceEmailStore).invoiceDelivery.fromEmail = $event),
        class: "multiselect w-6/12",
        type: "email",
        placeholder: "user@mycompany.com",
        required: "",
        onBlur: validateEmail,
        onChange: fromChange
      }, null, 40, _hoisted_25), [[_vModelText, _unref(invoiceEmailStore).invoiceDelivery.fromEmail]]), _createElementVNode("span", _hoisted_26, _toDisplayString(_unref(state).emailErrorMessage), 1)]), _createElementVNode("div", _hoisted_27, [_cache[44] || (_cache[44] = _createElementVNode("span", {
        class: "block font-bold text-base py-2 w-6/12"
      }, [_createTextVNode("Bcc "), _createElementVNode("span", {
        class: "text-gray-400 font-normal text-sm"
      }, "(recipient)")], -1)), _withDirectives(_createElementVNode("input", {
        disabled: _unref(state).reminderMode === '1' || _unref(state).reminderMode === '2',
        "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => _unref(state).emailBcc = $event),
        onBlur: _cache[15] || (_cache[15] = $event => validateEmails(_unref(state).emailBcc, false)),
        class: "multiselect w-full",
        type: "email",
        placeholder: "Separate multiple emails with commas",
        required: ""
      }, null, 40, _hoisted_28), [[_vModelText, _unref(state).emailBcc]]), _createElementVNode("span", _hoisted_29, _toDisplayString(_unref(state).emailBccErrorMessage), 1)])])]), _withDirectives(_createElementVNode("div", _hoisted_30, [_cache[46] || (_cache[46] = _createElementVNode("span", {
        class: "block font-bold text-base py-2"
      }, "Subject:", -1)), _createElementVNode("div", _hoisted_31, [!_unref(state).loadingSubjectId ? (_openBlock(), _createBlock(LlSelect, {
        key: 0,
        "data-cy": "dropdown",
        modelValue: _unref(invoiceEmailStore).invoiceDelivery.subjectId,
        "onUpdate:modelValue": [_cache[16] || (_cache[16] = $event => _unref(invoiceEmailStore).invoiceDelivery.subjectId = $event), _cache[17] || (_cache[17] = $event => subjectChange())],
        items: _unref(state).subjectOptions,
        "item-value": "value",
        "return-object": false,
        placeholder: "Pick Subject",
        class: "mb-0 at-subject",
        clearable: false,
        "hide-details": true
      }, null, 8, ["modelValue", "items"])) : _createCommentVNode("", true)])], 512), [[_vShow, _unref(state).reminderMode === '0']]), _withDirectives(_createElementVNode("div", _hoisted_32, [_cache[47] || (_cache[47] = _createElementVNode("span", {
        class: "block font-bold text-base py-2"
      }, "Reminder Subject:", -1)), _createElementVNode("div", _hoisted_33, [!_unref(state).loadingSubjectId ? (_openBlock(), _createBlock(LlSelect, {
        key: 0,
        modelValue: _unref(invoiceEmailStore).invoiceDelivery.reminderSubjectId,
        "onUpdate:modelValue": [_cache[18] || (_cache[18] = $event => _unref(invoiceEmailStore).invoiceDelivery.reminderSubjectId = $event), _cache[19] || (_cache[19] = $event => reminderSubjectChange())],
        items: _unref(state).reminderSubjectOptions,
        "item-value": "value",
        "return-object": false,
        placeholder: "Pick Reminder Subject",
        class: "mb-0",
        clearable: false,
        "hide-details": true
      }, null, 8, ["modelValue", "items"])) : _createCommentVNode("", true)])], 512), [[_vShow, _unref(state).reminderMode === '1']]), _withDirectives(_createElementVNode("div", _hoisted_34, [_cache[48] || (_cache[48] = _createElementVNode("span", {
        class: "block font-bold text-base py-2"
      }, "Trust Request Subject:", -1)), _createElementVNode("div", _hoisted_35, [!_unref(state).loadingSubjectId ? (_openBlock(), _createBlock(LlSelect, {
        key: 0,
        modelValue: _unref(invoiceEmailStore).invoiceDelivery.trustRequestSubjectId,
        "onUpdate:modelValue": [_cache[20] || (_cache[20] = $event => _unref(invoiceEmailStore).invoiceDelivery.trustRequestSubjectId = $event), _cache[21] || (_cache[21] = $event => trustRequestChange())],
        items: _unref(state).trustRequestSubjectOptions,
        "item-value": "value",
        "return-object": false,
        placeholder: "Pick Trust Request Subject",
        class: "mb-0",
        clearable: false,
        "hide-details": true
      }, null, 8, ["modelValue", "items"])) : _createCommentVNode("", true)])], 512), [[_vShow, _unref(state).reminderMode === '2']]), _withDirectives(_createElementVNode("div", _hoisted_36, [_createVNode(AttachmentItem, {
        label: "Invoice"
      }), isEnabled(_unref(state).modules, 7) ? (_openBlock(), _createBlock(AttachmentItem, {
        key: 0,
        label: "Trust Statement"
      })) : _createCommentVNode("", true), isEnabled(_unref(state).modules, 9) ? (_openBlock(), _createBlock(AttachmentItem, {
        key: 1,
        label: "Expense Attachments"
      })) : _createCommentVNode("", true), isEnabled(_unref(state).modules, 12) && _unref(state).me.features?.invoiceSummaryPage ? (_openBlock(), _createBlock(AttachmentItem, {
        key: 2,
        label: "Hours & Expenses Summary"
      })) : _createCommentVNode("", true)], 512), [[_vShow, _unref(state).reminderMode !== '2']]), _createElementVNode("span", _hoisted_37, _toDisplayString((_unref(state).reminderMode === '0' ? 'Body' : '') || (_unref(state).reminderMode === '1' ? 'Reminder Body' : '') || (_unref(state).reminderMode === '2' ? 'Trust Request Body' : '')), 1), _createElementVNode("div", _hoisted_38, [_createElementVNode("div", {
        class: _normalizeClass(["rounded border-gray-400 mt-2 py-2 pl-10 bg-white", {
          'border-2 border-[rgb(var(--v-theme-primary))]': _unref(state).showLogoChangeOnHover && _unref(state).reminderMode == 0,
          'opacity-50 cursor-not-allowed': _unref(state).reminderMode == 1,
          'cursor-pointer': _unref(state).reminderMode == 0
        }]),
        onMouseover: _cache[22] || (_cache[22] = $event => _unref(state).reminderMode == 0 ? _unref(state).showLogoChangeOnHover = true : ''),
        onMouseleave: _cache[23] || (_cache[23] = $event => _unref(state).reminderMode == 0 ? _unref(state).showLogoChangeOnHover = false : ''),
        onClick: _cache[24] || (_cache[24] = _withModifiers($event => _unref(state).reminderMode == 0 ? subjectLogo() : '', ["prevent"]))
      }, [_createElementVNode("div", _hoisted_39, [_unref(invoiceEmailStore).invoiceDelivery.logoUrl ? (_openBlock(), _createElementBlock("div", _hoisted_40, [!_unref(invoiceEmailStore).showUpdateLogoModal ? (_openBlock(), _createElementBlock("img", {
        key: 0,
        src: props.leanLawAuth.domain + '/v1/invoicedeliverysettings/logo'
      }, null, 8, _hoisted_41)) : _createCommentVNode("", true), _unref(invoiceEmailStore).showUpdateLogoModal ? (_openBlock(), _createBlock(_component_v_skeleton_loader, {
        key: 1,
        type: "image"
      })) : _createCommentVNode("", true)])) : (_openBlock(), _createElementBlock("div", _hoisted_42, [...(_cache[49] || (_cache[49] = [_createElementVNode("span", null, [_createElementVNode("svg", {
        width: "33",
        height: "33",
        viewBox: "0 0 33 33",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, [_createElementVNode("path", {
        d: "M4.125 5.5V1.375H6.875V5.5H11V8.25H6.875V12.375H4.125V8.25H0V5.5H4.125ZM8.25 13.75V9.625H12.375V5.5H22L24.5163 8.25H28.875C30.3875 8.25 31.625 9.4875 31.625 11V27.5C31.625 29.0125 30.3875 30.25 28.875 30.25H6.875C5.3625 30.25 4.125 29.0125 4.125 27.5V13.75H8.25ZM17.875 26.125C21.67 26.125 24.75 23.045 24.75 19.25C24.75 15.455 21.67 12.375 17.875 12.375C14.08 12.375 11 15.455 11 19.25C11 23.045 14.08 26.125 17.875 26.125ZM13.475 19.25C13.475 21.6838 15.4412 23.65 17.875 23.65C20.3088 23.65 22.275 21.6838 22.275 19.25C22.275 16.8162 20.3088 14.85 17.875 14.85C15.4412 14.85 13.475 16.8162 13.475 19.25Z",
        fill: "#C4C4C4"
      })])], -1), _createElementVNode("span", {
        class: "px-2 py-3 text-xs"
      }, "LOGO", -1)]))])), _createElementVNode("div", _hoisted_43, [_withDirectives(_createElementVNode("div", null, [...(_cache[50] || (_cache[50] = [_createElementVNode("span", {
        class: "text-gray-100 text-xs"
      }, [_createElementVNode("span", {
        class: "fa fa-pencil text-lg text-primary"
      })], -1)]))], 512), [[_vShow, _unref(state).showLogoChangeOnHover]])])])], 34), _createElementVNode("div", {
        class: _normalizeClass(["rounded border-gray-400 mt-2 py-2 pl-10 cursor-pointer bg-white", {
          'border-2 border-[rgb(var(--v-theme-primary))]': _unref(state).showIntroChangeOnHover
        }]),
        onMouseover: _cache[25] || (_cache[25] = $event => _unref(state).showIntroChangeOnHover = true),
        onMouseleave: _cache[26] || (_cache[26] = $event => _unref(state).showIntroChangeOnHover = false),
        onClick: _cache[27] || (_cache[27] = _withModifiers($event => introChange(), ["prevent"]))
      }, [_createElementVNode("div", _hoisted_44, [_createElementVNode("div", _hoisted_45, [_unref(state).reminderMode === '0' ? (_openBlock(), _createElementBlock("pre", _hoisted_46, _toDisplayString(_unref(state).body), 1)) : _createCommentVNode("", true), _unref(state).reminderMode === '1' ? (_openBlock(), _createElementBlock("pre", _hoisted_47, _toDisplayString(_unref(state).reminderBody), 1)) : _createCommentVNode("", true), _unref(state).reminderMode === '2' ? (_openBlock(), _createElementBlock("pre", _hoisted_48, _toDisplayString(_unref(state).trustRequestBody), 1)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_49, [_withDirectives(_createElementVNode("div", _hoisted_50, [...(_cache[51] || (_cache[51] = [_createElementVNode("span", {
        class: "text-gray-100 text-xs"
      }, [_createElementVNode("span", {
        class: "fa fa-pencil text-lg text-primary"
      })], -1)]))], 512), [[_vShow, _unref(state).showIntroChangeOnHover]])])])], 34), _createElementVNode("div", {
        class: _normalizeClass(["rounded border-gray-400 mt-2 py-2 pl-10 bg-white", {
          'border-2 border-[rgb(var(--v-theme-primary))]': _unref(state).showPayStyleOnHover,
          'opacity-50 cursor-not-allowed': _unref(state).reminderMode === '1' || _unref(state).reminderMode === '2',
          'cursor-pointer': _unref(state).reminderMode === '0'
        }]),
        onMouseover: _cache[28] || (_cache[28] = $event => _unref(state).reminderMode === '0' ? _unref(state).showPayStyleOnHover = true : ''),
        onMouseleave: _cache[29] || (_cache[29] = $event => _unref(state).reminderMode === '0' ? _unref(state).showPayStyleOnHover = false : ''),
        onClick: _cache[30] || (_cache[30] = _withModifiers($event => _unref(state).reminderMode === '0' ? buttonColorChange() : '', ["prevent"]))
      }, [_createElementVNode("div", _hoisted_51, [_createElementVNode("div", _hoisted_52, [_withDirectives(_createElementVNode("div", {
        class: "py-2 my-2 mr-2 w-2/5 rounded text-white text-center",
        style: _normalizeStyle({
          backgroundColor: _unref(state).buttonColor || '#000000'
        })
      }, " Pay Invoice ", 4), [[_vShow, showPayInvoiceButton.value && _unref(state).reminderMode !== '2']]), _withDirectives(_createElementVNode("div", {
        class: "py-2 my-2 w-2/5 rounded text-white text-center",
        style: _normalizeStyle({
          backgroundColor: _unref(state).buttonColor || '#000000'
        })
      }, " Pay Balance ", 4), [[_vShow, showPayBalanceButton.value && _unref(state).reminderMode !== '2']]), _withDirectives(_createElementVNode("div", {
        class: "py-2 my-2 w-2/5 rounded text-white text-center",
        style: _normalizeStyle({
          backgroundColor: _unref(state).buttonColor || '#000000'
        })
      }, " Pay Online ", 4), [[_vShow, _unref(state).reminderMode === '2']])]), _createElementVNode("div", _hoisted_53, [_withDirectives(_createElementVNode("div", _hoisted_54, [...(_cache[52] || (_cache[52] = [_createElementVNode("span", {
        class: "text-gray-100 text-xs"
      }, [_createElementVNode("span", {
        class: "fa fa-pencil text-lg text-primary"
      })], -1)]))], 512), [[_vShow, _unref(state).showPayStyleOnHover]])])])], 34), _withDirectives(_createElementVNode("div", {
        class: _normalizeClass(["rounded border-gray-400 mt-2 py-2 pl-10 bg-white", {
          'border-2 border-[rgb(var(--v-theme-primary))]': _unref(state).showAccountSummaryOnHover,
          'opacity-50 cursor-not-allowed': _unref(state).reminderMode === '1',
          'cursor-pointer': _unref(state).reminderMode === '0'
        }]),
        onMouseover: _cache[31] || (_cache[31] = $event => _unref(state).reminderMode === '0' ? _unref(state).showAccountSummaryOnHover = true : ''),
        onMouseleave: _cache[32] || (_cache[32] = $event => _unref(state).reminderMode === '0' ? _unref(state).showAccountSummaryOnHover = false : ''),
        onClick: _cache[33] || (_cache[33] = _withModifiers($event => _unref(state).reminderMode === '0' ? accountSummaryChange() : '', ["prevent"]))
      }, [_createElementVNode("div", _hoisted_55, [_cache[54] || (_cache[54] = _createElementVNode("div", {
        class: "w-11/12 flex justify-center"
      }, [_createElementVNode("div", {
        class: "py-2 my-2 mr-2 w-2/5 text-center"
      }, " Account Summary ")], -1)), _createElementVNode("div", _hoisted_56, [_withDirectives(_createElementVNode("div", _hoisted_57, [...(_cache[53] || (_cache[53] = [_createElementVNode("span", {
        class: "text-gray-100 text-xs"
      }, [_createElementVNode("svg", {
        width: "22",
        height: "22",
        viewBox: "0 0 22 22",
        class: "text-primary",
        xmlns: "http://www.w3.org/2000/svg"
      }, [_createElementVNode("path", {
        d: "M10.9993 5.50033C14.4735 5.50033 17.5718 7.45283 19.0844 10.542C17.5718 13.6312 14.4735 15.5837 10.9993 15.5837C7.52518 15.5837 4.42685 13.6312 2.91435 10.542C4.42685 7.45283 7.52518 5.50033 10.9993 5.50033ZM10.9993 3.66699C6.41602 3.66699 2.50185 6.51783 0.916016 10.542C2.50185 14.5662 6.41602 17.417 10.9993 17.417C15.5827 17.417 19.4969 14.5662 21.0827 10.542C19.4969 6.51783 15.5827 3.66699 10.9993 3.66699ZM10.9993 10.0837C12.2643 10.0837 13.291 11.1103 13.291 12.3753C13.291 13.6403 12.2643 12.8337 10.9993 12.8337C9.73435 12.8337 8.70768 11.807 8.70768 10.542C8.70768 9.27699 9.73435 8.25033 10.9993 8.25033M10.9993 6.41699C8.72602 6.41699 6.87435 8.26866 6.87435 10.542C6.87435 12.8153 8.72602 14.667 10.9993 14.667C13.2727 14.667 15.1244 12.8153 15.1244 10.542C15.1244 8.26866 13.2727 6.41699 10.9993 6.41699Z",
        fill: "currentColor"
      })])], -1)]))], 512), [[_vShow, _unref(state).showAccountSummaryOnHover]])])])], 34), [[_vShow, isEnabled(_unref(state).modules, 3) && _unref(state).reminderMode !== '2']])])])]), _createElementVNode("div", _hoisted_58, [_createVNode(EmailSidebar, {
        state: _unref(state)
      }, null, 8, ["state"]), _withDirectives(_createElementVNode("div", null, [_createVNode(LlSecondaryButton, {
        color: "primary",
        block: "",
        class: _normalizeClass(["my-4", {
          'cursor-not-allowed': !_unref(state).isEmailValid
        }]),
        onClick: _cache[34] || (_cache[34] = _withModifiers($event => update(), ["prevent"]))
      }, {
        default: _withCtx(() => [...(_cache[55] || (_cache[55] = [_createTextVNode(" Save Settings ", -1)]))]),
        _: 1
      }, 8, ["class"]), _createVNode(LlSecondaryButton, {
        block: "",
        class: "my-4",
        onClick: _cache[35] || (_cache[35] = _withModifiers($event => cancel(), ["prevent"]))
      }, {
        default: _withCtx(() => [...(_cache[56] || (_cache[56] = [_createTextVNode(" Cancel ", -1)]))]),
        _: 1
      }), _createElementVNode("div", _hoisted_59, [_withDirectives(_createElementVNode("div", _hoisted_60, [...(_cache[57] || (_cache[57] = [_createElementVNode("span", {
        class: "fa fa-warning"
      }, null, -1), _createTextVNode(" You have unsaved changes ", -1)]))], 512), [[_vShow, _unref(state).unsaved]])])], 512), [[_vShow, somethingChanged.value && !_unref(state).saving]])])])])]));
    };
  }
};